import ConfigService from "./ConfigService";
import HttpService from "./HttpService";


function replacer(key, value) {
  return value.replace(/[^\w\s]/gi, '');
}

export default class getNotificationServiceHost
{
    constructor(domain)
    {
        this.configService = new ConfigService();
        this.domain = domain || this.configService.getNotificationServiceHost();
    }



    async fetchVersion(token)
    {
        const path = "/api/admin/version";
        var response = await HttpService.get(this.domain, path, token);
        return response;   
    }

    async pingCore(token) 
    {
        const path = "/api/admin/ping";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }
        
      async postDirectNotificationRequest(emailRequest, gcid, token)
      {
        const path = "/api/notification/gcid/" + gcid + "/directtemplaterequest";

        var postObj = JSON.stringify(emailRequest);
        var cleanPostObj = postObj.replaceAll("\\", '');
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }

      async postSmsRequest(smsRequest, gcid, token)
      {
        const path = "/api/notification/gcid/" + gcid + "/smsrequest";

        var postObj = JSON.stringify(smsRequest);
        var cleanPostObj = postObj.replaceAll("\\", '');
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }


      async postScheduledNotificationRequest(emailRequest, gcid, token)
      {
        const path = "/api/notification/gcid/" + gcid + "/scheduledtemplateemailrequest";

        var postObj = JSON.stringify(emailRequest);
        var cleanPostObj = postObj.replaceAll("\\", '');
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }

      async postScheduledSmsRequest(smsRequest, gcid, token)
      {
        const path = "/api/notification/gcid/" + gcid + "/scheduledsmsrequest";

        var postObj = JSON.stringify(smsRequest);
        var cleanPostObj = postObj.replaceAll("\\", '');
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }


}